import React from 'react';
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';

const HypervergeUserCancelPopUp = (props) => {
    return (
        <Modal isOpen={props.userCancelled} centered>
            <ModalHeader toggle={props.toggleUserCancelled} style={{ borderBottom: "none" }}></ModalHeader>
            <img className="mt-3 text-center m-auto" style={{ width: "40px" }} src={process.env.REACT_APP_IMAGES_PATH + "hyperverge_failure.webp"} alt="result-icon" />
            <ModalBody className="succ-body">
                <div className='wrapper text-center m-2'>
                        <h5 className="offline-popup">Oops!!  </h5>
                            <p className="text-2 offline-popup-small mb-4"> It seems that you did not complete your journey. We encourage you to complete the KYC process to start investing. 

                            </p>
                            <Button className='mt-4' onClick={props?.reInitiateHyperverge}>Complete KYC</Button>
                </div>
            </ModalBody>
        </Modal>
    );
};

export default HypervergeUserCancelPopUp;
